import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Spinner } from "../../components/Layout";
import ForwarderQuoteForm from "../Form/forwarderQuoteForm";
import { useState } from "react";
import { log } from "../../Helper";
import { saveORupdateQuote } from "../api";
import { toast } from "react-toastify";
import FormSpinner from "../../avis/formControl/formSpinner";
import _ from "lodash";
import { getAccessToken } from "../../utils/okta-config";
import { API_ROOT } from "../../constants/constants";
import { Button, Typography} from "@deere/fuel-react";

const ForwarderQuoteDialog = (props) => {
  const {
    open,
    handleClose,
    selectedMachinesForQuote,
    openLoader,
    handleCloseLoader,
    getTableData,
    userData,
  } = props;

  const [startSpinner, setStartSpinner] = useState(false);

  const handleCloseSpinner = (event, reason) => {
    if (reason !== "backdropClick") {
      setStartSpinner(false);
    }
  };

  const [formData, setFormData] = useState({
    pickupdays: "",
    transitdays: "",
    amount: "",
    freetext: "",
  });
  const [dataUpdatedFlag, setDataUpdatedFlag] = useState();

  const handleUpdateFormData = (e) => {
    setFormData(e);
    log("formData", formData);
  };

  const handleUpdateFormDataFlag = (e) => {
    setDataUpdatedFlag(e);
  };

  const handleSubmit = () => {
    setStartSpinner(true);
    let isCorrect = true;
    if (
      !formData.pickupdays ||
      !formData.transitdays ||
      formData.pickupdays === "0" ||
      formData.transitdays === "0" ||
      !formData.amount ||
      formData.amount < 1 ||
      formData.amount > 100000
    ) {
      isCorrect = false;
      setStartSpinner(false);
    }

    if (!isCorrect) {
      toast.warn("Please enter the form inputs correctly.");
    } else if (
      selectedMachinesForQuote.submittedQuoteId &&
      !(
        dataUpdatedFlag &&
        isCorrect &&
        selectedMachinesForQuote.submittedQuoteId
      )
    ) {
      toast.warn("No data change to update");
      setStartSpinner(false);
    }

    if (
      (isCorrect && !selectedMachinesForQuote.submittedQuoteId) ||
      (dataUpdatedFlag &&
        isCorrect &&
        selectedMachinesForQuote.submittedQuoteId)
    ) {
      log("selectedMachinesForQuote- ", selectedMachinesForQuote);
      let url = `${process.env.REACT_APP_API_ENDPOINT}/forwarderquote/saveNewQuotes/`;
      const operationType = selectedMachinesForQuote.submittedQuoteId
        ? "EDIT"
        : "ADD"; //submittedQuoteId is only present in submitted quotes view.
      const reqObject = {
        submittedQuoteId: selectedMachinesForQuote.submittedQuoteId
          ? selectedMachinesForQuote.submittedQuoteId
          : "",
        supplierNumber: userData.supplierNumber,
        cost: formData.amount.props
          ? formData.amount.props.children[0]
          : formData.amount,
        pickupDays: formData.pickupdays,
        transitDays: formData.transitdays,
        operation: operationType,
        freeText: formData.freetext,
        currency: formData.currency,
        machineList: [
          {
            quoteId: selectedMachinesForQuote.quoteId,
            orderUnit: selectedMachinesForQuote.orderUnit,
            orderNumber: selectedMachinesForQuote.orderNumber,
            orderYear: selectedMachinesForQuote.orderYear,
          },
        ],
      };

      log("Req add quote ", reqObject);

      const request = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          operation: operationType,
          Authorization: `Bearer ${getAccessToken()}`,
          "Access-Control-Allow-Origin": API_ROOT,
        },
        body: JSON.stringify(reqObject),
      };

      saveORupdateQuote(url, request).then((response) => {
        if (response.httpResponse === 200) {
          setStartSpinner(false);
          toast.success(response.message);
          handleClose();
          getTableData();
        } else if (response.httpResponse === 400) {
          setStartSpinner(false);
          toast.warn(response.message);
          handleClose();
          getTableData();
        } else {
          setStartSpinner(false);
          toast.error(response.message);
          handleClose();
          getTableData();
        }
      });
    }
  };

  return (
    <>
      <div id="quote-dialog-div1" className=" w-[40%]">
        <Dialog
          id="quote-dialog1"
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth
        >
          <DialogTitle id="alert-dialog-title1">
            <Typography variant="h1">Add Quote</Typography>
          </DialogTitle>
          <DialogContent id="quote-dialog-content1">
            <ForwarderQuoteForm
              selectedMachinesForQuote={selectedMachinesForQuote}
              onUpdateFormData={handleUpdateFormData}
              dataUpdated={handleUpdateFormDataFlag}
            />
          </DialogContent>
          <DialogActions
            id="quote-dialog-actions1"
            style={{ marginTop: "-3rem", justifyContent: "center" }}
          >
            <Button
              id="quote-apply-btn"
              variant="primary"
              onClick={handleSubmit}
            >
              Apply
            </Button>
            <Button
              id="quote-cancel-btn"
              variant="secondary"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <FormSpinner
          startSpinner={startSpinner}
          handleCloseSpinner={handleCloseSpinner}
        />
      </div>

      <div id="quote-dialog-div3">
        <Dialog
          id="quote-dialog3"
          open={openLoader}
          onClose={handleCloseLoader}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth
        >
          <DialogTitle id="alert-dialog-title3"></DialogTitle>
          <DialogContent id="quote-dialog-content3">
            <div
              id="quote-dialog-spinner"
              className="d-flex w-100 justify-content-center align-items-center"
            >
              <Spinner
                accessibilityLabel="Loading"
                className="uxf-spinner-border-lg"
                animation="border"
              />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};

export default ForwarderQuoteDialog;
